import { CALL_API } from '../../middleware/api';
import { TRANSFORM } from '../../middleware/transform';
import * as ActionTypes from '../matchResults';
function fetchMatchResults(data) {
    var _a;
    return _a = {
            type: ActionTypes.FETCH_MATCH_RESULTS
        },
        _a[CALL_API] = {
            endpoint: '/api/match-results',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_FETCH_MATCH_RESULTS,
                ActionTypes.FAILURE_FETCH_MATCH_RESULTS
            ],
            credentials: true,
            data: data
        },
        _a[TRANSFORM] = {
            section: 'results',
            transformType: 'init',
            provider: function (data) { return data; }
        },
        _a;
}
export function getMatchResults(data) {
    return function (dispatch) {
        return dispatch(fetchMatchResults(data));
    };
}
export function clearMatchResult() {
    return function (dispatch) {
        return dispatch({ type: ActionTypes.CLEAR_MATCH_RESULTS, section: 'results' });
    };
}



// WEBPACK FOOTER //
// ./src/actions/creators/matchResults.js